export enum EMOTICON_TYPE {
  CHARACTER = 1,
  EMOJI = 2,
}

export enum EMOJI_TAB {
  RECENT = 'recent',
  PEOPLE = 'people',
  NATURE = 'nature',
  FOODS = 'foods',
  ACTIVITY = 'activity',
  PLACES = 'places',
  OBJECTS = 'objects',
  SYMBOLS = 'symbols',
  FLAGS = 'flags',
}

export const EMOJI_COLOR = ['gray', 'green', 'pink', 'yellow', 'blue'] as const;

export enum CHARACTER_EMOTICON_TAB {
  RECENT = 'recent',
  WEDAERI = 'wedaeri',
  GOGWAJANG = 'gogwajang',
  HASAWON = 'hasawon',
  DAHAGI = 'dahagi',
  TONGCA = 'tongca',
  ETC = 'etc',
}
